/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {homeMock} from './mock'

export const getHomepage = createAsyncThunk(
  'AnchorTeamPk/getHomepage',
  async (p: any, store: any) => {
    // return {...homeMock, ...p}
    const resp = await http.post(
      '/live/activity/ar_union_new_pk_homepage',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

export const getActivityInfo = createAsyncThunk(
  'AnchorTeamPk/getActivityInfo',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/commonactivity/get_activity_info',
      {...p},
      {
        store: window.store,
      }
    )

    return resp?.data?.data
  }
)

const initialState = {
  homepage: null,
  activityInfo: null,
}

export const AnchorTeamPkSlice = createSlice({
  name: 'AnchorTeamPk',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepage.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.homepage = data
    })
    builder.addCase(getActivityInfo.fulfilled, (state, action) => {
      const data = action.payload || {}
      state.activityInfo = data
    })
  },
})

export default AnchorTeamPkSlice.reducer

export const AnchorTeamPkSliceActions = AnchorTeamPkSlice.actions

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.AnchorTeamPk
  })
  return data
}
